import '@enterprise-ui/canvas-ui-css'
import {
  HeaderButton,
  CameraTreeButton,
  ModeName,
  StyledHeader,
  HeaderButtonContainer,
} from './styles'
import { HeaderItems } from './styles'
import EnterpriseIcon, {
  CancelIcon,
  CancelCircleIcon,
  StarIcon,
} from '@enterprise-ui/icons'
import { FunctionComponent } from 'react'
import './Header.css'
import CameraDomeIcon from '../CameraDrawer/icons/cameraDomeIcon.svg'
import { CAMERA_TREE, MONITOR_MODE } from '../../hooks/useMyTvs'

interface HeaderProps {
  headerText: string
  headerIcon: FunctionComponent<any>
  onIconClick: Function
  hasFeature: boolean
  featureOpen: boolean
  onCreateFavorite: Function
  showCreateFavorite: boolean
  clearAllCameras: Function
}

const Header = ({
  hasFeature,
  headerText,
  headerIcon,
  onIconClick,
  featureOpen,
  onCreateFavorite,
  showCreateFavorite,
  clearAllCameras,
}: HeaderProps) => {
  return (
    <StyledHeader>
      <HeaderItems>
        {hasFeature && !featureOpen && (
          <CameraTreeButton onClick={onIconClick} type="ghost">
            <EnterpriseIcon size={'md'} icon={headerIcon} />
          </CameraTreeButton>
        )}
        {headerText === CAMERA_TREE && <CameraDomeIcon />}
        <ModeName>{headerText}</ModeName>
        {hasFeature && featureOpen && (
          <CameraTreeButton
            onClick={onIconClick}
            type="ghost"
            className="close-button"
          >
            <EnterpriseIcon size={'md'} icon={CancelIcon} />
          </CameraTreeButton>
        )}
        {headerText === MONITOR_MODE && showCreateFavorite && (
          <HeaderButtonContainer>
            <HeaderButton
              onClick={clearAllCameras}
              type="ghost"
              size="expanded"
            >
              <EnterpriseIcon icon={CancelCircleIcon} size="lg" />
            </HeaderButton>
            <HeaderButton
              onClick={onCreateFavorite}
              type="ghost"
              size="expanded"
            >
              <EnterpriseIcon icon={StarIcon} size="lg" />
            </HeaderButton>
          </HeaderButtonContainer>
        )}
      </HeaderItems>
    </StyledHeader>
  )
}

export default Header
